$(document).ready(function(){
  $('.c-extra__check').change(function(){
    var extra = $(this).closest('.c-extra');
    var items = extra.find('.c-extra__item');
    var check = $(this);
    var item = check.closest('.c-extra__item');
    items.removeClass('c-extra__item--show');
    item.addClass('c-extra__item--show');
  });
});